export default __webpack_public_path__ + "static/photoshoot_2-09b7e10a8eb5abb49a296efeaf6d10d7.png";